/* An InfoBadge with a word: a dot for the state and a caption beside it, in
   a tinted 4px lozenge. */
.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: 1.25rem;
  padding: 0 var(--space-2);
  border-radius: var(--radius-sm);
  font-size: var(--text-xs);
  font-weight: 600;
  white-space: nowrap;
  background: var(--surface-sunken);
  color: var(--ink-muted);
}

/* A flat dot in the state's colour. Fluent's badges are filled circles, not
   lamps. */
.dot {
  width: 0.375rem;
  height: 0.375rem;
  border-radius: var(--radius-round);
  background: currentColor;
}

.badge[data-tone="ok"] {
  background: var(--ok-soft);
  color: var(--ok);
}

.badge[data-tone="warn"] {
  background: var(--warn-soft);
  color: var(--warn);
}

.badge[data-tone="error"] {
  background: var(--danger-soft);
  color: var(--danger);
}

/* Decided and still to do: an accepted design waiting to be built. */
.badge[data-tone="accent"] {
  background: var(--accent-soft);
  color: var(--accent);
}

/* Not set up: the ring of a dot, because there is no state to report yet. */
.badge[data-tone="off"] .dot {
  background: transparent;
  box-shadow: inset 0 0 0 1px currentColor;
}
